import { detectDupes } from "@liveblocks/core";

import { PKG_FORMAT, PKG_NAME, PKG_VERSION } from "./version";

detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);

export type {
  AiCopilot,
  CreateAiCopilotOptions,
  CreateFeedMessageOptions,
  CreateFeedOptions,
  CreateFileKnowledgeSourceOptions,
  CreateRoomOptions,
  CreateWebKnowledgeSourceOptions,
  GetAiCopilotsOptions,
  GetInboxNotificationsOptions,
  GetKnowledgeSourcesOptions,
  GetRoomsOptions,
  GetWebKnowledgeSourceLinksOptions,
  InboxNotificationsQueryCriteria,
  KnowledgeSource,
  LiveblocksOptions,
  MassMutateStorageCallback,
  MassMutateStorageOptions,
  MutateStorageCallback,
  MutateStorageOptions,
  Page,
  PaginationOptions,
  RoomAccesses,
  RoomData,
  RoomPermission,
  RoomsQueryCriteria,
  RoomUser,
  SetPresenceOptions,
  ThreadParticipants,
  UpdateAiCopilotOptions,
  UpdateFeedMessageOptions,
  UpdateFeedOptions,
  UpdateRoomOptions,
  UpsertRoomOptions,
  WebKnowledgeSourceLink,
} from "./client";
export { Liveblocks, LiveblocksError } from "./client";
export { markdownToCommentBody } from "./comment-body";
export type {
  CommentCreatedEvent,
  CommentDeletedEvent,
  CommentEditedEvent,
  CommentReactionAdded,
  CommentReactionRemoved,
  CustomNotificationEvent,
  NotificationEvent,
  RoomCreatedEvent,
  RoomDeletedEvent,
  StorageUpdatedEvent,
  TextMentionNotificationEvent,
  ThreadCreatedEvent,
  ThreadDeletedEvent,
  ThreadMarkedAsResolvedEvent,
  ThreadMarkedAsUnresolvedEvent,
  ThreadMetadataUpdatedEvent,
  ThreadNotificationEvent,
  UserEnteredEvent,
  UserLeftEvent,
  WebhookEvent,
  WebhookRequest,
  YDocUpdatedEvent,
} from "./webhooks";
export {
  isCustomNotificationEvent,
  isTextMentionNotificationEvent,
  isThreadNotificationEvent,
  WebhookHandler,
} from "./webhooks";
export type {
  CommentBody,
  CommentBodyBlockElement,
  CommentBodyElement,
  CommentBodyInlineElement,
  CommentBodyLink,
  CommentBodyLinkElementArgs,
  CommentBodyMention,
  CommentBodyMentionElementArgs,
  CommentBodyParagraph,
  CommentBodyParagraphElementArgs,
  CommentBodyText,
  CommentBodyTextElementArgs,
  CommentData,
  CommentUserReaction,
  IUserInfo,
  Json,
  JsonArray,
  JsonObject,
  JsonScalar,
  LiveStructure,
  Lson,
  LsonObject,
  PlainLsonObject,
  ResolveUsersArgs,
  StringifyCommentBodyElements,
  StringifyCommentBodyOptions,
  ThreadData,
  User,
} from "@liveblocks/core";
export {
  getMentionsFromCommentBody,
  isNotificationChannelEnabled,
  LiveList,
  LiveMap,
  LiveObject,
  stringifyCommentBody,
} from "@liveblocks/core";
